import Vue, { VNode, CreateElement } from 'vue';
import { RenderContext } from 'vue/types/options';

export const LoadingIndicator = Vue.extend({
    functional: true,
    name: 'LoadingIndicator',
    props: {
        classPostfix: String,
    },
    render(
        createElement: CreateElement,
        ctx: RenderContext<{ classPostfix: string }>
    ): VNode {
        return (
            <svg
                class={`loading-indicator ${ctx.props.classPostfix || ''}`}
                viewBox="0 0 50 50"
            >
                <circle
                    class="loading-indicator__ring"
                    cx="25"
                    cy="25"
                    r="20"
                />
                <circle
                    class="loading-indicator__ball"
                    cx="25"
                    cy="5"
                    r="3.5"
                />
            </svg>
        );
    },
});
